module.exports = __webpack_public_path__ + "static/media/a11ywins.aa08b83a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/a11ywins.jpg
// module id = 946
// module chunks = 0